import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
// import { AdBanner } from './AdBanner'; // 배너자리 주석 처리
// import { getStoreId } from '../utils/config';
import styles from './PageLayout.module.css';

interface PageLayoutProps {
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** 현재 대기 팀 수 (좌측 패널 표시용) */
  waitingCount?: number;
  /** 예상 대기 시간(분) */
  estimatedMinutes?: number;
  /** 포장 활성화 여부 */
  takeoutEnabled?: boolean;
  /** 포장 대기 팀 수 */
  takeoutWaitingCount?: number;
  /** 포장 예상 시간(분) */
  takeoutEstimatedMinutes?: number;
  /** 매장 이미지 (data URL 또는 URL). null이면 기본 이미지 사용 */
  storeImage?: string | null;
}

/**
 * 키오스크 2분할 레이아웃
 * - 좌측: 만석 배너 + 업체 이미지 + 웨이팅 현황
 * - 우측: 메인 콘텐츠 (전화번호 입력 등)
 */
export function PageLayout({
  title,
  children,
  footer,
  waitingCount = 0,
  estimatedMinutes = 0,
  takeoutEnabled = false,
  takeoutWaitingCount = 0,
  takeoutEstimatedMinutes = 0,
  storeImage = null,
}: PageLayoutProps) {
  const { t } = useLanguage();
  return (
    <div className={styles.container}>
      {/* 좌측: 정보 패널 */}
      <aside className={styles.infoPanel}>
        {/* 만석 배너 (가로로 긴 형태) */}
        <div className={styles.topBanner}>
          <img src="/banner2.png" alt="만석" className={styles.bannerLogo} />
        </div>

        {/* 업체 이미지 (16:9 비율) */}
        <div className={styles.storeImageWrapper}>
          {storeImage ? (
            <img
              src={storeImage}
              alt="매장 사진"
              className={styles.storeImage}
            />
          ) : (
            <div className={styles.storeImagePlaceholder}>
              <span className={styles.placeholderText}>업체 이미지</span>
              <span className={styles.placeholderHint}>(16:9)</span>
            </div>
          )}
        </div>

        {/* 웨이팅 현황 */}
        <div className={takeoutEnabled ? styles.waitingGrid4 : styles.waitingGrid}>
          <div className={styles.waitingCell}>
            <span className={styles.waitingLabel}>{t('waiting_current')}</span>
          </div>
          <div className={styles.waitingCell}>
            <span className={styles.waitingNumber}>{waitingCount}</span>
            <span className={styles.waitingUnit}>{t('unit_team')}</span>
          </div>
          <div className={styles.waitingCell}>
            <span className={styles.waitingLabel}>{t('waiting_estimated')}</span>
          </div>
          <div className={styles.waitingCell}>
            <span className={styles.waitingNumber}>{estimatedMinutes}</span>
            <span className={styles.waitingUnit}>{t('unit_minutes')}</span>
          </div>
          {takeoutEnabled && (
            <>
              <div className={styles.waitingCell}>
                <span className={styles.waitingLabel}>{t('waiting_takeout')}</span>
              </div>
              <div className={styles.waitingCell}>
                <span className={styles.waitingNumber}>{takeoutWaitingCount}</span>
                <span className={styles.waitingUnit}>{t('unit_team')}</span>
              </div>
              <div className={styles.waitingCell}>
                <span className={styles.waitingLabel}>{t('waiting_takeout_estimated')}</span>
              </div>
              <div className={styles.waitingCell}>
                <span className={styles.waitingNumber}>{takeoutEstimatedMinutes}</span>
                <span className={styles.waitingUnit}>{t('unit_minutes')}</span>
              </div>
            </>
          )}
        </div>
      </aside>

      {/* 우측: 메인 콘텐츠 */}
      <div className={styles.main}>
        {title && (
          <header className={styles.header}>
            <h1 className={styles.headerTitle}>{title}</h1>
          </header>
        )}
        <main className={styles.content}>{children}</main>
        {footer && <footer className={styles.footer}>{footer}</footer>}
      </div>

      {/* 배너자리 주석 처리
      <aside className={styles.bannerColumn}>
        <AdBanner storeId={storeId || ''} />
      </aside>
      */}
    </div>
  );
}
